export interface bl_applet_login_subject_link_ext_RowInterface {
  guid: string;
  link_guid: string;
  ext_type: string;
  ext_code: string;
  ext_option: string;
  property_json: any;
  param_code: string;
  param_name: string;
  param_type: string;
  param_option_json: any;
  value_string: string;
  value_file: string;
  value_numeric: number;
  value_datetime: Date;
  value_json: any;
  created_date: string;
  updated_date: string;
  status: string;
  revision: string;
  vrsn: string;
}

export class bl_applet_login_subject_link_ext_RowClass
  implements bl_applet_login_subject_link_ext_RowInterface
{
  guid: string;
  link_guid: string;
  ext_type: string;
  ext_code: string;
  ext_option: string;
  property_json: any;
  param_code: string;
  param_name: string;
  param_type: string;
  param_option_json: any;
  value_string: string;
  value_file: string;
  value_numeric: number;
  value_datetime: Date;
  value_json: any;
  created_date: string;
  updated_date: string;
  status: string;
  revision: string;
  vrsn: string;
}
